import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';


import { useHookStore } from "../../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../../utils/marks';

import "../DiffusionOptionsDesc/DiffusionOptionsDesc.css";

import EtaInputImage from "../../../image/for-style-change/for-about/sch-input-mountain-h125.jpeg";
import EtaMaskImage from "../../../image/for-style-change/option-description/eta/mountain-mask-h100.jpeg";
import EtaStyleImage from "../../../image/for-style-change/option-description/eta/sch-style-oil-painting-h100.jpeg";
import EtaOutputImage1 from "../../../image/for-style-change/option-description/eta/mountain-output-e0.1-h125.jpeg";
import EtaOutputImage2 from "../../../image/for-style-change/option-description/eta/mountain-output-e1.0-h125.jpeg";


function StyleChangeDescEta() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      // inputEta
    } = hStore.iopaintStore;

    return (
      <div className="diffsionOptionDesc">
        <div className="diffsionOptionDescRow">
          {t('diffusionOptions30', 'This input control image blurness of output image.')}
          <br/>
          {t('diffusionOptions31', 'When lower input value is used, clear and high contrast images are generated.')}
          {' '}{t('diffusionOptions32', 'When higher input values used, blur and less contrast images are generated.')}
          <br/>
          {t('diffusionOptions33', 'Default value 0.8 will generate balanced images.')}
          <br/>
          {t('diffusionOptions34', 'This is useful to adjust or control image output, when other inputs are same.')}
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={EtaInputImage}
              />
              {t('aboutPage.13', 'Input image')}
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={EtaMaskImage}
              />
              {t('aboutStyleChange05', 'Selected part')}
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={EtaStyleImage}
              />
              {t('aboutStyleChange06', 'Style image')}
            </div>
          </div>
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">

            <div>
              <img className="diffsionOptionDescImage"
                src={EtaOutputImage1}
              />
              0.1
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={EtaOutputImage2}
              />
              1.0
            </div>
          </div>
        </div>
      </div>
    )
  }


export default StyleChangeDescEta